import React from 'react';
import { Box, IconButton } from '@mui/material';
import {
  Pencil,
  TeamLogo1Url,
  TeamLogo2Url,
  TeamLogoPlaceholderUrl,
} from '@/static';
import styles from './styles';

const TEAMS_DATA = [
  {
    id: 1,
    name: 'Ομάδα Α',
    logo: TeamLogo1Url,
  },
  {
    id: 2,
    name: 'Ομάδα Β',
    logo: TeamLogo2Url,
  },
];

type TeamLogoInputProps = {
  teamId?: number;
  logoSrc?: string;
  onEditClick?: () => void;
};

const TeamLogoInput: React.FC<TeamLogoInputProps> = ({
  teamId,
  logoSrc,
  onEditClick,
}) => {
  const selectedTeam = TEAMS_DATA.find((team) => team.id === teamId);
  const finalLogoSrc = logoSrc || selectedTeam?.logo || TeamLogoPlaceholderUrl;

  const handleEditClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onEditClick?.();
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.logoContainer}>
        <Box
          component="img"
          src={finalLogoSrc}
          alt={selectedTeam?.name || 'Team logo placeholder'}
          sx={styles.logo}
        />

        <IconButton onClick={handleEditClick} sx={styles.editButton}>
          <Pencil />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TeamLogoInput;
